import { render } from "./Methodology.vue?vue&type=template&id=51a72428"
import script from "./Methodology.vue?vue&type=script&lang=js"
export * from "./Methodology.vue?vue&type=script&lang=js"

import exportComponent from "/Users/haoche/Documents/Parsons/2024 Spring/Major Studio 2/thesis/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__